<template>
  <div class="GoclearerApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="bussTitle">
      <el-image style="width:50px;height:50px; border-radius:5px;float:left" :src="setDetail.avatar" fit="cover"></el-image>
      <div class="name">
        <p>{{setDetail.username}}</p>
        <p>申请金额：￥{{setDetail.price}}</p>
      </div>
      <div class="status" :style="setDetail.status == 1 ? 'color:red' : setDetail.status == 2 ? 'color:green' : 'color:#ccc'">{{setDetail.status == 1 ? '申请中' : (setDetail.status == 2 ? '已完成':'未通过')}}</div>
    </div>
    <div class="sq">
      <div>
        <p>审核意见</p>
        <textarea placeholder="请输入审核意见" v-model="content"></textarea>
      </div>
    </div>
    <div class="btn" @click="update(2)" v-if="setDetail.status == 1">通过</div>
    <div style="background:#f00;margin-top:20px" class="btn" @click="update(3)" v-if="setDetail.status == 1">拒绝</div>

  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        content:'',
        setDetail:[],
        id:'',
        code:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideAllNonBaseMenuItem');
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/golarger?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/user/getLargerDetail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      update:function(status){
        var that = this;
        if(that.content == ''){
          that.$alert('请输入审核意见', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        var id = this.$route.query.id;
        that.fullscreenLoading = true;
        this.axios({
          'url': that.$host+'home/user/results',
          'method': 'post',
          params:{
            content:that.content,
            id:id,
            status:status
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          if(response.data.status == 200){
            that.$alert('审核成功。', '提示', {
              confirmButtonText: '确定'
            });
            that.getDetail();
          }else{
            that.$alert(response.data.message, '提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .GoclearerApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .GoclearerApp .sq{
    width: 94%;
    display: block;
    background: #fff;
    margin: 0px auto;
    border-radius: 5px;
    padding:15px 0
  }
  .GoclearerApp .sq textarea{
    width:88%;
    display:block;
    margin:0 auto;
    resize:none;
    outline:none;
    padding:1.5% 2%;
    border:solid 1px #ebebeb;
    height:90px;
    border-radius: 5px;
    font-size:15px;
  }
  .GoclearerApp .sq p{
    width:92%;
    display:block;
    margin:0 auto;
    font-size:15px;
    padding-bottom:8px;
  }

  .GoclearerApp .sq img{
    width:30%;
    border-radius: 5px;
    margin-top:15px;
    margin-right:15px;
  }
  .GoclearerApp .sq .pz{
    display:inline-block;
    vertical-align:top;
    margin-top:15px;
    width:30%;
    height:100px;
    border:solid 1px #ebebeb;
    text-align:center;
    font-size:14px;
    color:#666;
  }
  .GoclearerApp .sq .pz i{
    display:block;
    font-size:30px;
    padding-top:25px;
  }

  .GoclearerApp .btn{
    height: 45px;
    background: #007ae6;
    text-align: center;
    line-height: 45px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    border-radius: 6px;
    width:85%;
    margin:0 auto;
    margin-top:50px
  }

  .GoclearerApp .bussTitle{
    width:92%;
    margin:0 auto;
    padding:10px 4%;
    background:#fff;
    margin-bottom:15px;
  }
  .GoclearerApp .pro .bussTitle img{
    width:50px;
    border-radius:5px;
    float:left;
  }
  .GoclearerApp .bussTitle .name{
    float:left;
    width:68%;
    margin-left:2%
  }
  .GoclearerApp .bussTitle .name p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight:bold
  }
  .GoclearerApp .bussTitle .name p:last-child{
    font-size:12px;
    padding-top:10px;
    color:#999;
    font-weight:normal
  }
  .GoclearerApp .bussTitle .status{
    float:right;
    font-size:12px;
    color:#666;
    margin-top:12px;
    font-weight:bold;
  }
  .GoclearerApp .bussTitle:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }

</style>